import { Button } from "@/components/ui/button";
import type { ReactNode } from "react";
import { Plus } from "lucide-react";

/**
 * DB workout builder main panels (library + canvas).
 *
 * Notes:
 * - Canvas-only layout to avoid brittle two-column clipping.
 * - Keep these panels free of data-loading side effects; pass in callbacks/state from DBWorkoutBuilder.
 */
export default function DBWorkoutBuilderPanels({
  onOpenBrowse,
  canvas,
  canvasHeaderRight,
}: {
  onOpenBrowse: () => void;
  canvas: ReactNode;
  canvasHeaderRight: ReactNode;
}) {
  return (
    <div className="flex-1 min-h-0 p-4 pt-4">
      <div className="h-full rounded-2xl overflow-hidden border border-slate-200/70 bg-white flex flex-col shadow-sm">
        <div className="py-2 px-3 border-b flex flex-wrap items-center justify-between gap-2 sticky top-0 bg-gradient-to-r from-emerald-50 to-lime-50 backdrop-blur z-10">
          <span className="font-semibold">Workout Canvas</span>
          <div className="flex flex-wrap items-center gap-2">
            <Button
              size="sm"
              className="rounded-full bg-emerald-600 text-white hover:bg-emerald-700"
              onClick={onOpenBrowse}
            >
              <Plus className="w-4 h-4 mr-2" />
              Add exercises
            </Button>
            {canvasHeaderRight}
          </div>
        </div>
        <div className="flex-1 min-h-0">{canvas}</div>
      </div>
    </div>
  );
}

